import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import DatePicker from 'react-date-picker';
import moment from 'moment';

const DateQuestion = (props) => {
    const {onAnswer, questionIndex} = props;
    const [date, setDate] = useState(null);

    useEffect(() => {
        if (date) {
            const answer = [moment(date).format("MM-DD-YYYY")];
            if (onAnswer) {
                onAnswer(answer, questionIndex);
            }
        }
    }, [date])

    return (
        <div className="date-input-container" >
            <DatePicker
                onChange={(value) => setDate(value)}
                value={date}
                calendarIcon={false}
                clearIcon={false}
                className="date-input date-input-no-calendar"
                dayPlaceholder="DD"
                monthPlaceholder="MM"
                yearPlaceholder="YYYY"
            />
        </div>
    )
}

export default DateQuestion;